import { useTranslation } from 'react-i18next';

import { MessageIcon } from '@/lib/icon';
import { Flex, Text } from '@/lib/v2/components';

const SenderHeader = () => {
  const { t } = useTranslation();

  return (
    <Flex withGap gapSize="small">
      <MessageIcon />
      <Flex column itemAlignment="start">
        <Text className="text-inherit" color="black" fontWeight="normal">
          {t('CREATE_SENDER_MODAL.title')}
        </Text>
        <Text className="text-[0.7rem]" color="black" variant="text-sm">
          {t('CREATE_SENDER_MODAL.subTitle')}
        </Text>
      </Flex>
    </Flex>
  );
};

export default SenderHeader;
